import { UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { FieldTypeMeta } from '../../../lib/form-field-types';
import classes from './FieldPaletteTile.module.css';

export interface FieldPaletteTileProps {
  meta: FieldTypeMeta;
  onClick: () => void;
}

export function FieldPaletteTile({ meta, onClick }: FieldPaletteTileProps) {
  const { t } = useTranslation();

  return (
    <UnstyledButton className={classes.tile} onClick={onClick} aria-label={t(meta.labelKey)}>
      <span className={classes.icon}>{meta.icon}</span>
      <span className={classes.label}>{t(meta.labelKey)}</span>
    </UnstyledButton>
  );
}
